import { Load } from "./Load";
import { ExtraType } from "./ExtraType";
import { BookDirectOrder } from "../../features/bookDirect/model/BookDirectOrder";
import moment from "moment";
import { momentFromDateStringAndHour } from "../formatters";

export class CreateOrderRequestShipment {
  startAddressId: string;
  endAddressId: string;
  startTimeFrom: moment.Moment;
  startTimeTo: moment.Moment;
  endTimeFrom: moment.Moment;
  endTimeTo: moment.Moment;
  loads: Load[];
  extras: ExtraType[];
  pickupComment?: string;
  dropoffComment?: string;

  constructor(
    startAddressId: string,
    endAddressId: string,
    date: string,
    startWindow: [number, number],
    endWindow: [number, number],
    loads: Load[],
    extras: ExtraType[],
    pickupComment?: string,
    dropoffComment?: string
  ) {
    this.startAddressId = startAddressId;
    this.endAddressId = endAddressId;
    this.startTimeFrom = momentFromDateStringAndHour(date, startWindow[0]);
    this.startTimeTo = momentFromDateStringAndHour(date, startWindow[1]);
    this.endTimeFrom = momentFromDateStringAndHour(date, endWindow[0]);
    this.endTimeTo = momentFromDateStringAndHour(date, endWindow[1]);
    this.loads = loads;
    this.extras = extras;
    this.pickupComment = pickupComment;
    this.dropoffComment = dropoffComment;
  }

  static shipmentForDirectOrder = (
    order: BookDirectOrder
  ): CreateOrderRequestShipment => {
    const loads = order.loads.map(l => {
      // bad hack to send FE custom label to backend
      if (
        l.label === "nicht palettiert, eigenes Maß" ||
        l.label === "palettiert, eigenes Maß"
      ) {
        return {
          ...l,
          label: `${l.customLabel ? l.customLabel + ", " : ""}${l.label}`
        };
      }
      return l;
    });

    if (!order.date) throw new Error("validation failed: date missing");

    return new CreateOrderRequestShipment(
      order.startAddress.id!,
      order.endAddress.id!,
      order.date,
      order.startWindow,
      order.endWindow,
      loads,
      order.extras,
      order.pickupComment,
      order.dropoffComment
    );
  };
}
